// extracted by mini-css-extract-plugin
export var animationContainer = "_nc-0";
export var footer = "_nc-1";
export var gray = "_nc-2";
export var lineItem = "_nc-3";
export var lineItemImage = "_nc-4";
export var lineItemInfo = "_nc-5";
export var lineItemText = "_nc-6";
export var lineItems = "_nc-7";
export var modalContent = "_nc-8";
export var options = "_nc-9";
export var orderName = "_nc-a";
export var refundAmount = "_nc-b";